import React, { ReactElement } from 'react'

import s from './styles.module.scss'

import { InputField } from '../../../components/atoms/fields/input-field'
import IconSvg from '../../../components/atoms/icons/icon-svg'

const SearchUserAndTeams = ({
  search,
  setSearch,
  buttons,
  style = {},
}: {
  search: string
  setSearch: React.Dispatch<React.SetStateAction<string>>
  buttons?: ReactElement
  style?: React.CSSProperties
}) => {
  return (
    <div className={s.outerSearchbar} style={style}>
      <div className={s.containerSearchbar}>
        <div className={s.containerInputBar}>
          <InputField
            hideArrow
            placeholder='Chercher un utilisateur'
            isActive={false}
            Icon={IconSvg.Search}
            field={{
              value: search,
              onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                setSearch(e.target.value),
            }}
            fullWidth
            styleField={{ margin: 0 }}
          />
        </div>
        {!!buttons && buttons}
      </div>
    </div>
  )
}

export default SearchUserAndTeams
